export const visit = (vm, at) => {
vm(require("./availability/id.lyaml"));
vm(require("./typical-response-time/id.lyaml"));
vm(require("./default/id.lyaml"));
at({ "id": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "oke" } } });
};